/* eslint-disable max-len */
import React from "react"

import BaseSvgIcon from "../Base"

const CirclePerks = (props) => {
  return (
    <BaseSvgIcon {...props} viewBox="0 0 32 32">
      <circle cx="16" cy="16" r="16" fill="#0095FF" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.7606 9.313H18.2708C18.8812 8.41188 19.0549 7.50527 18.6286 7.0767C18.5415 6.99357 18.4394 6.92938 18.3283 6.88787C18.2171 6.84637 18.0992 6.82837 17.9813 6.83493C17.2216 6.91658 16.5092 7.25856 15.9552 7.80748C15.3994 7.25816 14.6852 6.91622 13.9239 6.83493C13.8059 6.82775 13.6878 6.84545 13.5766 6.88699C13.4654 6.92853 13.3634 6.99305 13.2766 7.0767C12.8503 7.50527 13.0239 8.41188 13.6344 9.313H14.7606ZM23.586 11.0548H16.8499V13.6867H23.4966C23.7176 13.6867 23.9296 13.5954 24.0864 13.4327C24.2431 13.2701 24.3319 13.0493 24.3333 12.8185V11.9174C24.3331 11.7026 24.2565 11.4955 24.1185 11.3361C23.9805 11.1768 23.7907 11.0765 23.586 11.0548ZM8.96269 24.0791C8.80675 23.9163 8.71915 23.6955 8.71915 23.4652V15.4285H15.1816V24.3334H9.55064C9.33011 24.3334 9.11862 24.2419 8.96269 24.0791ZM16.8499 24.3334H22.4651C22.6856 24.3334 22.8971 24.2419 23.053 24.0791C23.209 23.9163 23.2966 23.6955 23.2966 23.4652V15.4285H16.8499V24.3334ZM8.41918 11.0493H14.4554V11.0548H15.1816V13.6867H8.49812C8.27759 13.6867 8.0661 13.5952 7.91016 13.4324C7.75423 13.2696 7.66663 13.0488 7.66663 12.8186V11.9174C7.66688 11.7011 7.74397 11.4926 7.88299 11.3323C8.02201 11.1719 8.21306 11.0711 8.41918 11.0493Z"
        fill="white"
      />
    </BaseSvgIcon>
  )
}

export default CirclePerks
